import { TThunkAction } from '../../../../common/types/thunk';
import { EPlacingType, EServiceId } from '../../../types/reducers/publishTerms';
import { ECheckServicePromotionType, ECheckServicePublicationType } from '../../../services/checkService';
import {
  changeActiveServiceId,
  changePromotionService,
  changeSelectedPackageId,
  selectPlacingType,
} from '../../../actions/publishTerms';
import { reloadBetPosition } from '../../../actions/betPosition';
import { loadPublishTerms } from '../../publishTerms/loadPublishTerms';

import { PACKAGE_TYPES, PUBLICATION_TYPES } from './constants';
import { getPackageId } from './utils';
import { selectActivePackageId, selectPackages } from '../../../reducers/v2/publicationPackages/selectors';

interface IParams {
  publicationType: ECheckServicePublicationType;
  promotionType: ECheckServicePromotionType;
  serviceId: EServiceId;
}

export const changeSelectedServiceAfterCheckServiceV2 =
  ({ serviceId, promotionType, publicationType }: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();

    const isPromotionEnabled = promotionType !== ECheckServicePromotionType.noPromotion;

    if (isPromotionEnabled) {
      const enabledServiceId = serviceId === EServiceId.free ? EServiceId.paid : serviceId;
      // Нужно для случаев, когда у пользователя есть оплаченное продвижение, но он его выключил,
      // то включаем обратно продвижение, выбирая оплаченную услугу
      dispatch(changePromotionService(enabledServiceId));
      dispatch(changeActiveServiceId(enabledServiceId));
    }

    const isPublication = PUBLICATION_TYPES.includes(publicationType);
    // снова переключаемся на публикацию с баланса, на случай переключения в другой тип услуг
    if (isPublication) {
      dispatch(selectPlacingType(EPlacingType.balance));
    }

    const isPackage = PACKAGE_TYPES.includes(publicationType);
    // снова переключаемся в пакеты, на случай переключения в другой тип услуг
    if (isPackage) {
      const packages = selectPackages(state);
      const packageId = getPackageId({ packages, serviceId, publicationType });
      const currentSelectedPackageId = selectActivePackageId(state);

      if (currentSelectedPackageId !== packageId) {
        dispatch(loadPublishTerms({ isServicesReload: true }));
      }

      dispatch(changeSelectedPackageId(packageId));
      dispatch(selectPlacingType(EPlacingType.package));
    }

    dispatch(reloadBetPosition());
  };
